import type { DocNode } from '@atlaskit/adf-schema';
import { bridgeEventEmitter } from '@databases/rovo-bridge';
import { useCallback } from 'react';

import { BoeSubmitPromptCommand } from '@canvas/databases-bridge-api/commands';
import { CONFLUENCE_AFM_CLIENT_ID } from '@canvas/databases-bridge-api/types';
import { client } from '@canvas/rovo-content-bridge-api';

const getPlainTextFromADF = (prompt: DocNode): string => {
  // Extract plain text from ADF DocNode by recursively walking the node tree
  let plainText = '';

  const walk = (
    node: DocNode | { type?: string; text?: string; content?: unknown[] }
  ) => {
    if (node.type === 'text') {
      plainText += node.text ?? '';
    }

    if (node.content) {
      node.content.forEach((child) =>
        walk(child as { type?: string; text?: string; content?: unknown[] })
      );
    }
  };

  walk(prompt);

  return plainText.trim();
};

export const useDatabaseBlankObjectSubmit = ({
  contentId,
  onSubmit
}: {
  contentId: string;
  onSubmit?: () => void;
}) => {
  return useCallback(
    (prompt: DocNode) => {
      onSubmit?.();
      bridgeEventEmitter.sendEvent(BoeSubmitPromptCommand, {
        senderId: client(`confluence-database-${contentId}`),
        receiverId: CONFLUENCE_AFM_CLIENT_ID,
        prompt: getPlainTextFromADF(prompt),
        contentId
      });
    },
    [contentId, onSubmit]
  );
};
